import { createClient } from '@connectrpc/connect';
import { igniteTransport } from '~/services/api/service-transport';
import { IgniteUserService } from '~/types/wavin/ignite/v1/ignite_user_service_pb';

export const igniteUserPromiseClient = createClient(
  IgniteUserService,
  igniteTransport,
);
